import { Grid } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import AllForms from "./AllForms";
import { useAxios } from "../../../../hooks";
import { ButtonFooter } from "../../../../components";
import HeadersAndButtons from "./forms/PageHeaders";

export default function FormDisplay({
  audiences,
  editState,
  liveUsers,
  categories,
  formikProps,
  takeUpOffer,
  audienceData,
  setEditState,
  component = "",
  brandDetails,
  setTakeUpOffer,
  setBrandDetails,
  setAudienceData,
  setAudienceCreated,
  preferredChannels,
  connectionList,
}) {
  const axios = useAxios();
  const channelSectionRef = useRef(null);

  const [audienceSize, setAudienceSize] = useState({
    values: {},
  });
  const [isSubmitted, setIsSubmitted] = useState(() =>
    checkChannelFields(formikProps.values)
  );
  const [forceClick, setForceClick] = useState(true);
  const [brandIdentity, setBrandIdentity] = useState(false);

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (formikProps.values.brandID) {
      if (parseInt(formikProps.values.brandID) !== parseInt(activeBrand.ID)) {
        setBrandIdentity(true);
      }
    }
  }, [formikProps.values.brandID, activeBrand.ID]);

  useEffect(() => {
    axios({
      url: "/get/audienceSizing",
      method: "POST",
      data: {
        brand_id: parseInt(activeBrand.ID),
        campaign_id: parseInt(formikProps.values.campaignID),
        audience_id: parseInt(audienceData.ID),
      },
      disableRedirect: true,
      disableError: true,
    }).then((audienceSize) => {
      if (audienceSize.status) {
        setAudienceSize(() => ({
          values: {
            audience_params: audienceSize.data?.audience_params,
            audience_size: audienceSize.data?.audience_size,
            audience_pricing: audienceSize.data?.audience_pricing,
            distinctCategories: audienceSize.data?.distinctCategories,
          },
        }));
      }
    });
  }, [activeBrand.ID, formikProps.values.campaignID, audienceData.ID, axios]);

  return (
    <Grid container spacing={4}>
      <HeadersAndButtons
        channelSectionRef={channelSectionRef}
        editState={editState}
        liveUsers={liveUsers}
        formikProps={formikProps}
        setEditState={setEditState}
        component={component}
        setTakeUpOffer={setTakeUpOffer}
        connectionList={connectionList}
        preferredChannels={preferredChannels}
        forceClick={forceClick}
        setForceClick={setForceClick}
        audienceSize={audienceSize}
        brandIdentity={brandIdentity}
        setIsSubmitted={setIsSubmitted}
        isSubmitted={isSubmitted}
        activeBrand={activeBrand}
      />

      <AllForms
        channelSectionRef={channelSectionRef}
        audienceData={audienceData}
        audiences={audiences}
        editState={editState}
        liveUsers={liveUsers}
        categories={categories}
        formikProps={formikProps}
        takeUpOffer={takeUpOffer}
        brandDetails={brandDetails}
        component={component}
        setBrandDetails={setBrandDetails}
        setAudienceData={setAudienceData}
        setAudienceCreated={setAudienceCreated}
        preferredChannels={preferredChannels}
        forceClick={forceClick}
        isSubmitted={isSubmitted}
        audienceSize={audienceSize}
      />

      {editState && (
        <Grid size={12}>
          <ButtonFooter
            ID={formikProps.values.campaignID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Grid>
      )}
    </Grid>
  );
}

export function checkChannelFields(values) {
  const prefChannels = values?.pref_campaign_channel?.value || [];

  let requiredFields = [];

  if (prefChannels.includes(3)) {
    requiredFields.push("ad_manager_id");
  }

  if (prefChannels.includes(6)) {
    requiredFields.push(
      "dv_partner_id",
      "dv_advertiser_id",
      "dv_advertiser_name"
    );
  }

  // remove duplicates in case both 3 and 6 are selected
  requiredFields = [...new Set(requiredFields)];

  return requiredFields.every((field) => !!values?.[field]?.value);
}
